import { defaultThemeColors as colors } from "./colors";
import { fonts } from "./fonts";

export const theme = {
  colors,
  fonts,
};
